<div *ngIf="loading" id="load"></div>
<div class="wrapper" style="position: relative;" infinite-scroll [infiniteScrollDistance]="distance"
  [infiniteScrollThrottle]="throttle" (scrolled)="onScroll()">
  <div class="heading-field">
    <div class="heading" style="display: flex;">
      <span
        class="material-symbols-outlined arrow-icon"
        [ngbTooltip]="goBack"
        tooltipClass="custom_tooltip"
        placement="top-start"
        triggers="manual"
        #goBack1="ngbTooltip"
        (mouseleave)="goBack1.close()"
        (mouseover)="goBack1.open()"
        (click)="navigateBack()"
      >arrow_left_alt</span>

      <ng-template #goBack class="custom_tooltip">Go Back</ng-template>
      <span>{{ selectedTemplateName }}</span>
    </div>
    <div class="template-header-section pt-3 pb-3">
      <div class="search-bar">
        <button type="submit" class="msicon" (keyup.enter)="searchButton()"><span class="material-symbols-outlined">
            search</span></button>
        <input type="search" class="form-control" [(ngModel)]="searchText"
          placeholder="Search for Artifactory by Tags, Type, Description, DocumentText, etc..."
          (keydown.enter)="searchButton()" (keyup)="clearSearch()" [class.searchClose]="searchText==''">
        <button type="submit" class="msicon" (click)="clearSearchText()" *ngIf="searchText!=''"><span
            class="material-symbols-outlined"> close </span></button>
      </div>

      <button class="btn custom_btn primary_btn_base d-flex align-items-center add_proposal_btn"
        (click)="addTemplate()"><i class="iconplus mr-1">
          <span class="material-symbols-outlined fs-18 blue-clr">
            add
          </span></i><span class="btn-create">Add Artifactory</span>
      </button>
    </div>
    <div style="padding-top: 5px;">
      <ng-container *ngTemplateOutlet="viewAndExportControls"></ng-container>
    </div>

  </div>

  <!-- <div id="backset" style="height:45px;"></div> -->
  <!-- <app-breadcrumb></app-breadcrumb> -->

  <div class="docs" *ngIf="!searchResultsViewFlag">
    <div
      infinite-scroll
      [infiniteScrollDistance]="distance"
      [infiniteScrollThrottle]="throttle"
      (scrolled)="onScroll()"
    >
      <div class="row ml-0 carporate-deck-cards" *ngIf="currentDocuments && !searchResultsViewFlag">
        <ng-container *ngIf="artifactoryView === 'card'">
          <div class="col-xl-3 col-lg-3 col-md-6 pl-0" *ngFor="let doc of currentDocuments">

            <div class="custom_card">
              <div class="custom_card_inner">
                <div class="d-flex justify-content-between bder-bottom pb-2">
                  <div class="d-flex" style="width: 80%;">
                    <div class="card_image mr-2">
                      <img src="{{'data:image/jpg;base64,' + doc.logo}}">
                    </div>
                    <div class="card_title">
                      <div [ngbTooltip]="projectNameTooltip" tooltipClass="custom_tooltip" placement="top"
                        triggers="manual" #tooltip="ngbTooltip" (mouseleave)="tooltip.close()"
                        (mouseover)="tooltip.open()">
                        <ng-template #projectNameTooltip class="custom_tooltip">{{doc.fileName}}</ng-template>
                        {{doc.fileName}}
                      </div>
                      <div>
                          <span class="d-flex">
                            <span [ngSwitch]="true" class="d-flex align-items-center">
                              <ng-container *ngSwitchCase="doc.averageRating == 5">
                                      <span *ngFor="let item of [1,2,3,4,5]" class="material-icons checked fs-14">star</span>
                                      <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                              </ng-container>

                              <ng-container *ngSwitchCase="doc.averageRating >= 4 && doc.averageRating < 5">
                                <ng-container *ngIf="doc.averageRating == 4; else lessThanFive">
                                  <span *ngFor="let item of [1,2,3,4]" class="material-icons checked fs-14">star</span>
                                  <span class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                                </ng-container>
                                <ng-template #lessThanFive>
                                  <span *ngFor="let item of [1,2,3]" class="material-icons checked fs-14">star</span>
                                  <span *ngIf="doc.averageRating < 4.9" class="material-icons checked fs-14">star_half</span>
                                  <span class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                                </ng-template>
                              </ng-container>

                              <ng-container *ngSwitchCase="doc.averageRating >= 3 && doc.averageRating < 4">
                                <ng-container *ngIf="doc.averageRating == 3; else lessThanFour">
                                  <span *ngFor="let item of [1,2,3]" class="material-icons checked fs-14">star</span>
                                  <span *ngFor="let item of [1,2]" class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                                </ng-container>
                                <ng-template #lessThanFour>
                                  <span *ngFor="let item of [1,2,3]" class="material-icons checked fs-14">star</span>
                                  <span *ngIf="doc.averageRating < 3.9" class="material-icons checked fs-14">star_half</span>
                                  <span class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                                </ng-template>
                              </ng-container>

                              <ng-container *ngSwitchCase="doc.averageRating >= 2 && doc.averageRating < 3">
                                <ng-container *ngIf="doc.averageRating == 2; else lessThanThree">
                                  <span *ngFor="let item of [1,2]" class="material-icons checked fs-14">star</span>
                                  <span *ngFor="let item of [1,2,3]" class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                                </ng-container>
                                <ng-template #lessThanThree>
                                  <span *ngFor="let item of [1,2]" class="material-icons checked fs-14">star</span>
                                  <span *ngIf="doc.averageRating < 2.9" class="material-icons checked fs-14">star_half</span>
                                  <span *ngFor="let item of [1,2]" class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                                </ng-template>
                              </ng-container>

                              <ng-container *ngSwitchCase="doc.averageRating >= 1 && doc.averageRating < 2">
                                <ng-container *ngIf="doc.averageRating == 1; else lessThanTwo">
                                  <span class="material-icons checked fs-14">star</span>
                                  <span *ngFor="let item of [1,2,3,4]" class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                                </ng-container>
                                <ng-template #lessThanTwo>
                                  <span class="material-icons checked fs-14">star</span>
                                  <span *ngIf="doc.averageRating < 1.9" class="material-icons checked fs-14">star_half</span>
                                  <span *ngFor="let item of [1,2,3]" class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                                </ng-template>
                              </ng-container>

                              <ng-container *ngSwitchDefault>
                                  <span *ngFor="let item of [1,2,3,4,5]" class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                              </ng-container>
                            </span>
                            <span><a class="view_all cursor_pointer" (click)="openRatingTemplate(doc)">View
                                all</a></span>
                          </span>
                        </div>
                    </div>
                  </div>
                  <div class="card_menu">
                    <div class="dropdown">
                      <span class="material-symbols-outlined fs-16 cursor_pointer mr-2"
                        [ngClass]="{'disabled-button': canDownload}" (click)="viewFile(doc.sharepointId,doc.id)">
                        visibility
                      </span>

                      <span class="material-symbols-outlined fs-16 cursor_pointer" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        more_vert
                      </span>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item cursor_pointer d-flex align-items-center"
                          [ngClass]="{'disabled-button': canDownload}" (click)="openEditTemplate(doc)"
                          *ngIf="isAuthorizedUser(doc)">
                          <span class="material-symbols-outlined fs-16 mr-2">edit</span>
                          <span>Edit</span>
                        </a>
                        <a *ngIf="adminSuperAdminLeadership"
                          class="dropdown-item cursor_pointer d-flex align-items-center"
                          [ngClass]="{'disabled-button': canDownload}"
                          (click)="downloadTemplate(doc.id,doc.sharepointId,doc.name)">
                          <span class="material-symbols-outlined fs-16 mr-2">download</span>
                          <span>Download</span>
                        </a>
                        <a class="dropdown-item cursor_pointer" [hidden]="!doc.gitLink" href="{{ doc.gitLink }}"
                          target="_blank" [ngClass]="{'disabled-button': canDownload}">
                          <span class="d-flex align-items-center">
                            <span class="material-symbols-outlined fs-16 mr-2">linked_services</span>
                            <span>Git</span>
                          </span>
                        </a>
                        <a class="dropdown-item cursor_pointer d-flex align-items-center"
                          (click)="openUpdateTemplate(doc,'singleFile')">
                          <span class="material-symbols-outlined fs-16 mr-2">drive_file_move</span>
                          <span>Change</span>
                        </a>
                        <a class="dropdown-item cursor_pointer d-flex align-items-center"
                          [ngClass]="{'disabled-button': canDownload}" (click)="openDeleteTemplate(doc,'singleFile')"
                          *ngIf="superAdminAndAdmin">
                          <span class="material-symbols-outlined fs-16 mr-2">delete</span>
                          <span>Delete</span>
                        </a>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="d-flex bder-bottom pb-2 pt-2">
                  <div class="w-50 pr-3">
                    <div class="card_label">Type</div>
                    <div class="card_value ellipsis_one_line_text" [ngbTooltip]="projectType1"
                      tooltipClass="custom_tooltip" placement="top bottom" triggers="manual" (click)="projectType.open()"
                      #projectType="ngbTooltip" (mouseleave)="projectType.close()" (mouseover)="projectType.open()"
                      *ngIf="doc.subCategoryTemplate!=null">
                      <ng-template #projectType1 class="custom_tooltip">{{doc.subCategoryTemplate}}</ng-template>
                      {{doc.subCategoryTemplate}}
                    </div>
                  </div>
                  <div class="w-50">
                    <div class="card_label">Purpose</div>
                    <div class="card_value ellipsis_one_line_text" tooltipClass="custom_tooltip"
                      [ngbTooltip]="projectPurpose1" placement="top bottom" triggers="manual"
                      (click)="projectPurpose.open()" #projectPurpose="ngbTooltip" (mouseleave)="projectPurpose.close()"
                      (mouseover)="projectPurpose.open()">
                      <ng-template #projectPurpose1 class="custom_tooltip">{{doc.purposeOfUsage}}</ng-template>
                      {{doc.purposeOfUsage}}
                    </div>
                  </div>
                </div>
                <div class="card_description bder-bottom pb-2 pt-2">
                  <div class="card_label">Description</div>
                  <div class="card_value ellipsis_three_line_text fw-400" tooltipClass="custom_tooltip"
                    [ngbTooltip]="projectDescription1" placement="top bottom" triggers="manual"
                    (click)="projectDescription.open()" #projectDescription="ngbTooltip"
                    (mouseleave)="projectDescription.close()" (mouseover)="projectDescription.open()">
                    <ng-template #projectDescription1 class="custom_tooltip">{{doc.templateDescription}}</ng-template>
                    {{doc.templateDescription}}
                  </div>
                </div>
                <div class="d-flex pt-2 pb-2">
                  <div class="w-50 pr-3">
                    <div class="card_label d-flex align-items-center">
                      <span class="material-symbols-outlined fs-16 card_label mr-1">
                        sell
                      </span>
                      <span> Related Tags </span>
                    </div>
                    <div class="card_value card_value_icon_style ellipsis_one_line_text ml-1"
                      [ngbTooltip]="projectTagsTooltip" tooltipClass="custom_tooltip" placement="top bottom"
                      triggers="manual" (click)="tooltipTags.open()" #tooltipTags="ngbTooltip"
                      (mouseleave)="tooltipTags.close()" (mouseover)="tooltipTags.open()">
                      <ng-template #projectTagsTooltip class="custom_tooltip">{{doc.templateTags.join()}}</ng-template>
                      {{doc.templateTags}}
                    </div>
                  </div>
                  <div class="w-50">
                    <div class="card_label d-flex align-items-center">
                      <span class="material-symbols-outlined fs-16 card_label mr-1">
                        person
                      </span>
                      <span> Contact Person </span>
                    </div>
                    <div class="card_value card_value_icon_style ellipsis_one_line_text ml-1"
                      tooltipClass="custom_tooltip" [ngbTooltip]="contactPerson1" placement="top bottom" triggers="manual"
                      (click)="contactPerson.open()" #contactPerson="ngbTooltip" (mouseleave)="contactPerson.close()"
                      (mouseover)="contactPerson.open()">
                      <ng-template #contactPerson1 class="custom_tooltip">{{doc.contactPerson}}</ng-template>
                      {{doc.contactPerson}}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </ng-container>
        <ng-container *ngIf="artifactoryView === 'table'">
          <table mat-table [dataSource]="currentDocuments" matSort class="proposal_data">
                <ng-container matColumnDef="fileName">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    class="custom-mat-header-cell"
                  > Artifact Name
                  </th>
                  <td mat-cell *matCellDef="let row" class="custom-mat-cell">
                    <div
                      class="truncateValue"
                      [ngbTooltip]="projectNameTooltip"
                      tooltipClass="custom_tooltip"
                      triggers="manual"
                      #tooltip="ngbTooltip"
                      (mouseleave)="tooltip.close()"
                      (mouseover)="tooltip.open()"
                    >
                      <ng-template #projectNameTooltip class="custom_tooltip">
                        {{row.fileName}}
                      </ng-template>
                      {{row.fileName}}
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="subCategoryTemplate">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    class="custom-mat-header-cell"
                  > Type </th>
                  <td mat-cell *matCellDef="let row" class="custom-mat-cell">
                    <div
                      class="truncateValue"
                      [ngbTooltip]="projectNameTooltip"
                      tooltipClass="custom_tooltip"
                      triggers="manual"
                      #tooltip="ngbTooltip"
                      (mouseleave)="tooltip.close()"
                      (mouseover)="tooltip.open()"
                    >
                      <ng-template #projectNameTooltip class="custom_tooltip">
                        {{row.subCategoryTemplate}}
                      </ng-template>
                      {{row.subCategoryTemplate}}
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="templateName">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    class="custom-mat-header-cell"
                  > Purpose
                  </th>
                  <td mat-cell *matCellDef="let row" class="custom-mat-cell">
                    <div
                      class="truncateValue"
                      [ngbTooltip]="projectNameTooltip"
                      tooltipClass="custom_tooltip"
                      triggers="manual"
                      #tooltip="ngbTooltip"
                      (mouseleave)="tooltip.close()"
                      (mouseover)="tooltip.open()"
                    >
                      <ng-template #projectNameTooltip class="custom_tooltip">
                        {{row.templateName}}
                      </ng-template>
                      {{row.templateName}}
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="templateDescription">
                  <th mat-header-cell *matHeaderCellDef class="custom-mat-header-cell"> Description </th>
                  <td mat-cell *matCellDef="let row" class="custom-mat-cell">
                    <div
                      class="truncateValue"
                      [ngbTooltip]="projectNameTooltip"
                      tooltipClass="custom_tooltip"
                      triggers="manual"
                      #tooltip="ngbTooltip"
                      (mouseleave)="tooltip.close()"
                      (mouseover)="tooltip.open()"
                    >
                      <ng-template #projectNameTooltip class="custom_tooltip">
                        {{row.templateDescription}}
                      </ng-template>
                      {{row.templateDescription}}
                    </div>
                    
                  </td>
                </ng-container>

                <ng-container matColumnDef="templateTags">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    class="custom-mat-header-cell"
                  > Related Tags
                  </th>
                  <td mat-cell *matCellDef="let row" class="custom-mat-cell">
                    <div
                      class="truncateValue"
                      [ngbTooltip]="projectNameTooltip"
                      tooltipClass="custom_tooltip"
                      triggers="manual"
                      #tooltip="ngbTooltip"
                      (mouseleave)="tooltip.close()"
                      (mouseover)="tooltip.open()"
                    >
                      <ng-template #projectNameTooltip class="custom_tooltip">
                        {{row.templateTags.join(', ')}}
                      </ng-template>
                      {{row.templateTags.join(', ')}}
                    </div>
                    
                  </td>
                </ng-container>

                <ng-container matColumnDef="contactPerson">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    class="custom-mat-header-cell"
                  > Contact Person
                  </th>
                  <td mat-cell *matCellDef="let row" class="custom-mat-cell">
                    <div
                      class="truncateValue"
                      [ngbTooltip]="projectNameTooltip"
                      tooltipClass="custom_tooltip"
                      triggers="manual"
                      #tooltip="ngbTooltip"
                      (mouseleave)="tooltip.close()"
                      (mouseover)="tooltip.open()"
                    >
                      <ng-template #projectNameTooltip class="custom_tooltip">
                        {{row.contactPerson}}
                      </ng-template>
                      {{row.contactPerson}}
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="custom-mat-header-cell"> Actions </th>
                  <td mat-cell *matCellDef="let doc" class="custom-mat-cell">
                    <div class="btns">
                      <div class="dropdown">
                        <span class="material-symbols-outlined fs-16 cursor_pointer mr-2"
                          [ngClass]="{'disabled-button': canDownload}" (click)="viewFile(doc.sharepointId,doc.id)">
                          visibility
                        </span>

                        <span
                          class="material-symbols-outlined fs-16 cursor_pointer"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          more_vert
                        </span>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a class="dropdown-item cursor_pointer d-flex align-items-center"
                            [ngClass]="{'disabled-button': canDownload}" (click)="openEditTemplate(doc)"
                            *ngIf="isAuthorizedUser(doc)">
                            <span class="material-symbols-outlined fs-16 mr-2">edit</span>
                            <span>Edit</span>
                          </a>
                          <a *ngIf="adminSuperAdminLeadership"
                            class="dropdown-item cursor_pointer d-flex align-items-center"
                            [ngClass]="{'disabled-button': canDownload}"
                            (click)="downloadTemplate(doc.id,doc.sharepointId,doc.name)">
                            <span class="material-symbols-outlined fs-16 mr-2">download</span>
                            <span>Download</span>
                          </a>
                          <a class="dropdown-item cursor_pointer" [hidden]="!doc.gitLink" href="{{ doc.gitLink }}"
                            target="_blank" [ngClass]="{'disabled-button': canDownload}">
                            <span class="d-flex align-items-center">
                              <span class="material-symbols-outlined fs-16 mr-2">linked_services</span>
                              <span>Git</span>
                            </span>
                          </a>
                          <a class="dropdown-item cursor_pointer d-flex align-items-center"
                            (click)="openUpdateTemplate(doc,'singleFile')">
                            <span class="material-symbols-outlined fs-16 mr-2">drive_file_move</span>
                            <span>Change</span>
                          </a>
                          <a class="dropdown-item cursor_pointer d-flex align-items-center"
                            [ngClass]="{'disabled-button': canDownload}"
                            (click)="openDeleteTemplate(doc,'singleFile')" *ngIf="superAdminAndAdmin">
                            <span class="material-symbols-outlined fs-16 mr-2">delete</span>
                            <span>Delete</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  [class.odd]="i % 2 == 1"
                  [class.even]="i % 2 == 0"
                  mat-row
                  *matRowDef="let row; columns: displayedColumns; let i = index;"
                ></tr>
                </table>
                <mat-paginator
                  [length]="selectedTemplateDocCount"
                  [pageSize]="5"
                  [pageSizeOptions]="[5,10,20,50]"
                  aria-label="Select page"
                  (page)="getPaginatorData($event)"
                ></mat-paginator>
        </ng-container>
      </div>
      <div *ngIf="currentDocuments.length == 0&&!loading">
        <!-- <mat-card class="mt-3">
          <mat-card-content class="no-records custom_subtiles1 fs-25 noDataCell">No Records Found</mat-card-content>
        </mat-card> -->
        <div class="noDataCard">
          <div class="noDataCardIn">
            <img src="../../../assets/images/no_data.png" height="120px"><br>
            <span class="mt-3 d-block"> No Records Found</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="docs" *ngIf="searchResultsViewFlag">
    <div infinite-scroll [infiniteScrollDistance]="distance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScroll()">
      <div class="row m-0">
        <div class="fs-18 fw-600 pb-2 docs_heading" id="carousel">
          Search Results ({{templateResponse.length}})
        </div>
      </div>
      <div class="row ml-0 carporate-deck-cards" *ngIf="templateResponse && searchResultsViewFlag;">
        <ng-container *ngIf="artifactoryView === 'card'">
          <div class="col-xl-3 col-lg-3 col-md-6 pl-0" *ngFor="let doc of templateResponse">

            <div class="custom_card">
              <div class="custom_card_inner">
                <div class="d-flex justify-content-between bder-bottom pb-2">
                  <div class="d-flex" style="width: 80%;">
                    <div class="card_image mr-2">
                      <img src="{{'data:image/jpg;base64,' + doc.logo}}">
                    </div>
                    <div class="card_title">
                      <div [ngbTooltip]="projectNameTooltip" tooltipClass="custom_tooltip" placement="top"
                        triggers="manual" #tooltip="ngbTooltip" (mouseleave)="tooltip.close()"
                        (mouseover)="tooltip.open()">
                        <ng-template #projectNameTooltip class="custom_tooltip">{{doc.fileName}}</ng-template>
                        {{doc.fileName}}
                      </div>
                        <div>
                          <span class="d-flex">
                            <span [ngSwitch]="true" class="d-flex align-items-center">
                              <ng-container *ngSwitchCase="doc.averageRating == 5">
                                <span *ngFor="let item of [1,2,3,4,5]" class="material-icons checked fs-14">star</span>
                                <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                              </ng-container>

                              <ng-container *ngSwitchCase="doc.averageRating >= 4 && doc.averageRating < 5">
                                <ng-container *ngIf="doc.averageRating == 4; else lessThanFive">
                                  <span *ngFor="let item of [1,2,3,4]" class="material-icons checked fs-14">star</span>
                                  <span class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                                </ng-container>
                                <ng-template #lessThanFive>
                                  <span *ngFor="let item of [1,2,3]" class="material-icons checked fs-14">star</span>
                                  <span *ngIf="doc.averageRating < 4.9" class="material-icons checked fs-14">star_half</span>
                                  <span class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                                </ng-template>
                              </ng-container>

                              <ng-container *ngSwitchCase="doc.averageRating >= 3 && doc.averageRating < 4">
                                <ng-container *ngIf="doc.averageRating == 3; else lessThanFour">
                                  <span *ngFor="let item of [1,2,3]" class="material-icons checked fs-14">star</span>
                                  <span *ngFor="let item of [1,2]" class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                                </ng-container>
                                <ng-template #lessThanFour>
                                  <span *ngFor="let item of [1,2,3]" class="material-icons checked fs-14">star</span>
                                  <span *ngIf="doc.averageRating < 3.9" class="material-icons checked fs-14">star_half</span>
                                  <span class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                                </ng-template>
                              </ng-container>

                              <ng-container *ngSwitchCase="doc.averageRating >= 2 && doc.averageRating < 3">
                                <ng-container *ngIf="doc.averageRating == 2; else lessThanThree">
                                  <span *ngFor="let item of [1,2]" class="material-icons checked fs-14">star</span>
                                  <span *ngFor="let item of [1,2,3]" class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                                </ng-container>
                                <ng-template #lessThanThree>
                                  <span *ngFor="let item of [1,2]" class="material-icons checked fs-14">star</span>
                                  <span *ngIf="doc.averageRating < 2.9" class="material-icons checked fs-14">star_half</span>
                                  <span *ngFor="let item of [1,2]" class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                                </ng-template>
                              </ng-container>

                              <ng-container *ngSwitchCase="doc.averageRating >= 1 && doc.averageRating < 2">
                                <ng-container *ngIf="doc.averageRating == 1; else lessThanTwo">
                                  <span class="material-icons checked fs-14">star</span>
                                  <span *ngFor="let item of [1,2,3,4]" class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                                </ng-container>
                                <ng-template #lessThanTwo>
                                  <span class="material-icons checked fs-14">star</span>
                                  <span *ngIf="doc.averageRating < 1.9" class="material-icons checked fs-14">star_half</span>
                                  <span *ngFor="let item of [1,2,3]" class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                                </ng-template>
                              </ng-container>

                              <ng-container *ngSwitchDefault>
                                  <span *ngFor="let item of [1,2,3,4,5]" class="material-icons un_checked fs-14">star</span>
                                  <span class="rating_count mr-2">({{ doc.ratingsCount}})</span>
                              </ng-container>
                            </span>
                            <span><a class="view_all cursor_pointer" (click)="openRatingTemplate(doc)">View
                                all</a></span>
                          </span>
                        </div>
                    </div>
                  </div>
                  <div class="card_menu">
                    <div class="dropdown">
                      <span class="material-symbols-outlined fs-16 cursor_pointer mr-2"
                        [ngClass]="{'disabled-button': canDownload}" (click)="viewFile(doc.sharepointId,doc.id)">
                        visibility
                      </span>

                      <span class="material-symbols-outlined fs-16 cursor_pointer" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        more_vert
                      </span>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item cursor_pointer d-flex align-items-center"
                          [ngClass]="{'disabled-button': canDownload}" (click)="openEditTemplate(doc)"
                          *ngIf="isAuthorizedUser(doc)">
                          <span class="material-symbols-outlined fs-16 mr-2">edit</span>
                          <span>Edit</span>
                        </a>
                        <a *ngIf="adminSuperAdminLeadership"
                          class="dropdown-item cursor_pointer d-flex align-items-center"
                          [ngClass]="{'disabled-button': canDownload}"
                          (click)="downloadTemplate(doc.id,doc.sharepointId,doc.name)">
                          <span class="material-symbols-outlined fs-16 mr-2">download</span>
                          <span>Download</span>
                        </a>
                        <a class="dropdown-item cursor_pointer" [hidden]="!doc.gitLink" href="{{ doc.gitLink }}"
                          target="_blank" [ngClass]="{'disabled-button': canDownload}">
                          <span class="d-flex align-items-center">
                            <span class="material-symbols-outlined fs-16 mr-2">linked_services</span>
                            <span>Git</span>
                          </span>
                        </a>
                        <a class="dropdown-item cursor_pointer d-flex align-items-center"
                          (click)="openUpdateTemplate(doc,'singleFile')">
                          <span class="material-symbols-outlined fs-16 mr-2">drive_file_move</span>
                          <span>Change</span>
                        </a>
                        <a class="dropdown-item cursor_pointer d-flex align-items-center"
                          [ngClass]="{'disabled-button': canDownload}" (click)="openDeleteTemplate(doc,'singleFile')"
                          *ngIf="superAdminAndAdmin">
                          <span class="material-symbols-outlined fs-16 mr-2">delete</span>
                          <span>Delete</span>
                        </a>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="d-flex bder-bottom pb-2 pt-2">
                  <div class="w-50 pr-3">
                    <div class="card_label">Type</div>
                    <div class="card_value ellipsis_one_line_text" [ngbTooltip]="projectType1"
                      tooltipClass="custom_tooltip" placement="top bottom" triggers="manual" (click)="projectType.open()"
                      #projectType="ngbTooltip" (mouseleave)="projectType.close()" (mouseover)="projectType.open()"
                      *ngIf="doc.subCategoryTemplate!=null">
                      <ng-template #projectType1 class="custom_tooltip">{{doc.subCategoryTemplate}}</ng-template>
                      {{doc.subCategoryTemplate}}
                    </div>
                  </div>
                  <div class="w-50">
                    <div class="card_label">Purpose</div>
                    <div class="card_value ellipsis_one_line_text" tooltipClass="custom_tooltip"
                      [ngbTooltip]="projectPurpose1" placement="top bottom" triggers="manual"
                      (click)="projectPurpose.open()" #projectPurpose="ngbTooltip" (mouseleave)="projectPurpose.close()"
                      (mouseover)="projectPurpose.open()">
                      <ng-template #projectPurpose1 class="custom_tooltip">{{doc.purposeOfUsage}}</ng-template>
                      {{doc.purposeOfUsage}}
                    </div>
                  </div>
                </div>
                <div class="card_description bder-bottom pb-2 pt-2">
                  <div class="card_label">Description</div>
                  <div class="card_value ellipsis_three_line_text fw-400" tooltipClass="custom_tooltip"
                    [ngbTooltip]="projectDescription1" placement="top bottom" triggers="manual"
                    (click)="projectDescription.open()" #projectDescription="ngbTooltip"
                    (mouseleave)="projectDescription.close()" (mouseover)="projectDescription.open()">
                    <ng-template #projectDescription1 class="custom_tooltip">{{doc.templateDescription}}</ng-template>
                    {{doc.templateDescription}}
                  </div>
                </div>
                <div class="d-flex pt-2 pb-2">
                  <div class="w-50 pr-3">
                    <div class="card_label d-flex align-items-center">
                      <span class="material-symbols-outlined fs-16 card_label mr-1">
                        sell
                      </span>
                      <span> Related Tags </span>
                    </div>
                    <div class="card_value card_value_icon_style ellipsis_one_line_text ml-1"
                      [ngbTooltip]="projectTagsTooltip" tooltipClass="custom_tooltip" placement="top bottom"
                      triggers="manual" (click)="tooltipTags.open()" #tooltipTags="ngbTooltip"
                      (mouseleave)="tooltipTags.close()" (mouseover)="tooltipTags.open()">
                      <ng-template #projectTagsTooltip class="custom_tooltip">{{doc.templateTags.join()}}</ng-template>
                      {{doc.templateTags}}
                    </div>
                  </div>
                  <div class="w-50">
                    <div class="card_label d-flex align-items-center">
                      <span class="material-symbols-outlined fs-16 card_label mr-1">
                        person
                      </span>
                      <span> Contact Person </span>
                    </div>
                    <div class="card_value card_value_icon_style ellipsis_one_line_text ml-1"
                      tooltipClass="custom_tooltip" [ngbTooltip]="contactPerson1" placement="top bottom" triggers="manual"
                      (click)="contactPerson.open()" #contactPerson="ngbTooltip" (mouseleave)="contactPerson.close()"
                      (mouseover)="contactPerson.open()">
                      <ng-template #contactPerson1 class="custom_tooltip">{{doc.contactPerson}}</ng-template>
                      {{doc.contactPerson}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="artifactoryView === 'table'">
          <table mat-table [dataSource]="templateResponseForTable" matSort class="proposal_data">
                <ng-container matColumnDef="fileName">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    class="custom-mat-header-cell"
                  > Artifact Name
                  </th>
                  <td mat-cell *matCellDef="let row" class="custom-mat-cell">
                    <div
                      class="truncateValue"
                      [ngbTooltip]="projectNameTooltip"
                      tooltipClass="custom_tooltip"
                      triggers="manual"
                      #tooltip="ngbTooltip"
                      (mouseleave)="tooltip.close()"
                      (mouseover)="tooltip.open()"
                    >
                      <ng-template #projectNameTooltip class="custom_tooltip">
                        {{row.fileName}}
                      </ng-template>
                      {{row.fileName}}
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="subCategoryTemplate">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    class="custom-mat-header-cell"
                  > Type </th>
                  <td mat-cell *matCellDef="let row" class="custom-mat-cell">
                    <div
                      class="truncateValue"
                      [ngbTooltip]="projectNameTooltip"
                      tooltipClass="custom_tooltip"
                      triggers="manual"
                      #tooltip="ngbTooltip"
                      (mouseleave)="tooltip.close()"
                      (mouseover)="tooltip.open()"
                    >
                      <ng-template #projectNameTooltip class="custom_tooltip">
                        {{row.subCategoryTemplate}}
                      </ng-template>
                      {{row.subCategoryTemplate}}
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="templateName">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    class="custom-mat-header-cell"
                  > Purpose
                  </th>
                  <td mat-cell *matCellDef="let row" class="custom-mat-cell">
                    <div
                      class="truncateValue"
                      [ngbTooltip]="projectNameTooltip"
                      tooltipClass="custom_tooltip"
                      triggers="manual"
                      #tooltip="ngbTooltip"
                      (mouseleave)="tooltip.close()"
                      (mouseover)="tooltip.open()"
                    >
                      <ng-template #projectNameTooltip class="custom_tooltip">
                        {{row.templateName}}
                      </ng-template>
                      {{row.templateName}}
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="templateDescription">
                  <th mat-header-cell *matHeaderCellDef class="custom-mat-header-cell"> Description </th>
                  <td mat-cell *matCellDef="let row" class="custom-mat-cell">
                    <div
                      class="truncateValue"
                      [ngbTooltip]="projectNameTooltip"
                      tooltipClass="custom_tooltip"
                      triggers="manual"
                      #tooltip="ngbTooltip"
                      (mouseleave)="tooltip.close()"
                      (mouseover)="tooltip.open()"
                    >
                      <ng-template #projectNameTooltip class="custom_tooltip">
                        {{row.templateDescription}}
                      </ng-template>
                      {{row.templateDescription}}
                    </div>
                    
                  </td>
                </ng-container>

                <ng-container matColumnDef="templateTags">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    class="custom-mat-header-cell"
                  > Related Tags
                  </th>
                  <td mat-cell *matCellDef="let row" class="custom-mat-cell">
                    <div
                      class="truncateValue"
                      [ngbTooltip]="projectNameTooltip"
                      tooltipClass="custom_tooltip"
                      triggers="manual"
                      #tooltip="ngbTooltip"
                      (mouseleave)="tooltip.close()"
                      (mouseover)="tooltip.open()"
                    >
                      <ng-template #projectNameTooltip class="custom_tooltip">
                        {{row.templateTags.join(', ')}}
                      </ng-template>
                      {{row.templateTags.join(', ')}}
                    </div>
    
                  </td>
                </ng-container>

                <ng-container matColumnDef="contactPerson">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    class="custom-mat-header-cell"
                  > Contact Person
                  </th>
                  <td mat-cell *matCellDef="let row" class="custom-mat-cell">
                    <div
                      class="truncateValue"
                      [ngbTooltip]="projectNameTooltip"
                      tooltipClass="custom_tooltip"
                      triggers="manual"
                      #tooltip="ngbTooltip"
                      (mouseleave)="tooltip.close()"
                      (mouseover)="tooltip.open()"
                    >
                      <ng-template #projectNameTooltip class="custom_tooltip">
                        {{row.contactPerson}}
                      </ng-template>
                      {{row.contactPerson}}
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="custom-mat-header-cell"> Actions </th>
                  <td mat-cell *matCellDef="let doc" class="custom-mat-cell">
                    <div class="btns">
                      <div class="dropdown">
                        <span class="material-symbols-outlined fs-16 cursor_pointer mr-2"
                          [ngClass]="{'disabled-button': canDownload}" (click)="viewFile(doc.sharepointId,doc.id)">
                          visibility
                        </span>

                        <span
                          class="material-symbols-outlined fs-16 cursor_pointer"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          more_vert
                        </span>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a class="dropdown-item cursor_pointer d-flex align-items-center"
                            [ngClass]="{'disabled-button': canDownload}" (click)="openEditTemplate(doc)"
                            *ngIf="isAuthorizedUser(doc)">
                            <span class="material-symbols-outlined fs-16 mr-2">edit</span>
                            <span>Edit</span>
                          </a>
                          <a *ngIf="adminSuperAdminLeadership"
                            class="dropdown-item cursor_pointer d-flex align-items-center"
                            [ngClass]="{'disabled-button': canDownload}"
                            (click)="downloadTemplate(doc.id,doc.sharepointId,doc.name)">
                            <span class="material-symbols-outlined fs-16 mr-2">download</span>
                            <span>Download</span>
                          </a>
                          <a class="dropdown-item cursor_pointer" [hidden]="!doc.gitLink" href="{{ doc.gitLink }}"
                            target="_blank" [ngClass]="{'disabled-button': canDownload}">
                            <span class="d-flex align-items-center">
                              <span class="material-symbols-outlined fs-16 mr-2">linked_services</span>
                              <span>Git</span>
                            </span>
                          </a>
                          <a class="dropdown-item cursor_pointer d-flex align-items-center"
                            (click)="openUpdateTemplate(doc,'singleFile')">
                            <span class="material-symbols-outlined fs-16 mr-2">drive_file_move</span>
                            <span>Change</span>
                          </a>
                          <a class="dropdown-item cursor_pointer d-flex align-items-center"
                            [ngClass]="{'disabled-button': canDownload}"
                            (click)="openDeleteTemplate(doc,'singleFile')" *ngIf="superAdminAndAdmin">
                            <span class="material-symbols-outlined fs-16 mr-2">delete</span>
                            <span>Delete</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  [class.odd]="i % 2 == 1"
                  [class.even]="i % 2 == 0"
                  mat-row
                  *matRowDef="let row; columns: displayedColumns; let i = index;"
                ></tr>
                </table>
                <mat-paginator
                  [length]="templateResponse.length"
                  [pageSize]="5"
                  [pageSizeOptions]="[5,10,20,50]"
                  aria-label="Select page"
                  (page)="getPaginatorData($event)"
                ></mat-paginator>
        </ng-container>
      </div>

      <div *ngIf="templateResponse.length == 0&&!loading" class="d-flex justify-content-center">
        <!-- <mat-card class="">
          <mat-card-content class="no-records custom_subtiles1 fs-25 noDataCell">No Records Found</mat-card-content>
        </mat-card> -->
        <div class="noDataCard">
          <div class="noDataCardIn">
            <img src="../../../assets/images/no_data.png" height="120px"><br>
            <span class="mt-3 d-block"> No Records Found</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- table, grid icons -->
<ng-template #viewAndExportControls>
  <div class="view d-flex align-items-end toggle_align">
    <button class="button-icon me-2 cursor-pointer" (click)="toggleView('card')">
      <span class="material-symbols-sharp recently-upladed-icons filled-icon">
        grid_view
      </span>
    </button>
    <button class="button-icon me-2 cursor-pointer" (click)="toggleView('table')">
      <span class="material-symbols-sharp recently-upladed-icons filled-icon">
        view_list
      </span>
    </button>
    <button class="button-icon cursor-pointer" (click)="exportToExcel()">
      <span class="material-symbols-outlined recently-upladed-icons"> download </span>
    </button>
  </div>
</ng-template>